import { ActionButton, Container, Icon, Image, Text } from "@jds/core";
import banner from "../assets/png/not connected 1.png";
import React from "react";

const NoNetwork = () => {
  return (
    <Container
      fullWidth
      verticalAlign="center"
      style={{ height: "100vh" }}
      horizontalAlign="center"
    >
      <Container direction="column" horizontalAlign="center" gap={7}>
        <Container
          style={{
            height: "180px",
            width: "180px",
          }}
        >
          <Image src={banner} aspectRatio="1:1" />
        </Container>
        <Text appearance="heading-xs">No Internet Connection</Text>
        <Container
          fullWidth
          horizontalAlign="center"
          style={{ margin: "16px 0 20px" }}
          direction="column"
          gap={1}
        >
          <Text appearance="body-m" color="primary_grey_80">
            The features in this area require Internet
          </Text>
          <Text appearance="body-m" color="primary_grey_80">
            connectivity. Please connect your computer
          </Text>
          <Text appearance="body-m" color="primary_grey_80">
            to the Internet & Try Again.
          </Text>
        </Container>
        <Container style={{ width: "150px", marginTop: "24px" }}>
          <ActionButton
            size="large"
            label="Retry"
            stretch
            onClick={() => {
              window.location.reload();
            }}
          />
        </Container>
      </Container>
    </Container>
  );
};

export default NoNetwork;
